import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfSentimentReportTimeSeriesApplicationService } from '../../../core/application/services/sentiment/get-self-sentiment-report-time-series.application-service';
import { SelfSentimentReportTimeSeriesEntity } from '../../../core/domain/entities/sentiment/self-sentiment-report-time-series.entity';
import { GetSelfSentimentReportTimeSeriesRequestDto } from '../../dtos/sentiment/get-self-sentiment-report-time-series.request.dto';

export class GetSelfSentimentReportTimeSeriesQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfSentimentReportTimeSeriesApplicationService
  ) {}
  async execute(
    props: GetSelfSentimentReportTimeSeriesRequestDto
  ): Promise<SelfSentimentReportTimeSeriesEntity[]> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
